import { StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const style = StyleSheet.create({
  container: { flex: 1, marginTop: 8, marginBottom: 32, marginHorizontal: 14 },
  icon: {
    padding: 4,
    position: 'absolute',
    top: -8,
    right: -8,
  },
  closeIcon: {
    color: neutrals.neutralGrays.smoke,
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 26,
    textAlign: 'center',
    color: neutrals.neutralGrays.graphite,
    margin: 'auto',
  },
  contentWrapper: {
    marginTop: 16,
    gap: 20,
  },
});
